module.exports = __webpack_public_path__ + "static/sighthub-f65a1476dd5a23ac06860dd796748f7b.jpg";